import { useMutation, useQuery } from "@apollo/client";
import { globalVariables } from "helper/globalVariables";
import { useEffect, useImperativeHandle, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import {
  GET_USER_DETAIL,
  UPDATE_USER_BY_ADMIN,
} from "redux/features/superAdminSlice/manageUsersSlice/manageUsersGql";
import { BottomButtons } from "shared/Components/bottomButtons";
import Loader from "shared/Components/loader";
import { PhoneInput } from "shared/Components/phoneInput";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { TextInput } from "shared/Components/textInput";
import { TextArea } from "shared/Components/textarea";
import Dropdown from "shared/Components/dropdown";
import { judgeBasicDetailsResolver } from "validators/UserValidation";
import { SubmitButton } from "./Components/SubmitButtons";
import { backIcon } from "helper/icons";

const EditAbleJudgeProfile = () => {
  const { id } = useParams();
  const formRef = useRef();
  const [loader, setloader] = useState(false);
  const [updatedData, setUpdatedData] = useState({});
  const [distance, setDistance] = useState("");
  const navigate = useNavigate();
  const { loading, data } = useQuery(GET_USER_DETAIL, {
    variables: { authId: id },
  });

  const distanceOptions = [
    "Any Distance",
    "Up to 50 miles",
    "Up to 100 miles",
    "Up to 150 miles",
    "Up to 200 miles",
    "Up to 300 miles",
    "300+ miles",
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
  } = useForm({
    resolver: judgeBasicDetailsResolver,
  });
  useEffect(() => {
    if (data) {
      reset({
        name: data.getUserDetail.name,
        email: data.getUserDetail.email,
        address: data.getUserDetail.location_address,
        phoneNumber: data.getUserDetail.phone_number,
      });
      setDistance(data.getUserDetail.distance_travel || "");
    }
  }, [data, reset]);

  useImperativeHandle(formRef, () => ({
    saveChanges() {
      onCheckValidation();
    },
  }));

  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const showBtns = useMediaQuery({ query: "(max-width: 768px)" });
  const modalRef = useRef();
  const [profileDataSave, setProfileDataSave] = useState({
    title: "",
    desc: "",
    type: "success",
  });

  const [updateProfile] = useMutation(UPDATE_USER_BY_ADMIN, {
    variables: {
      authId: id,
      data: updatedData,
    },
  });

  const handelSaveChanges = () => {
    formRef.current.saveChanges();
  };

  const handleCancel = () => {
    navigate("/admin/manage/users?page=refresh");
  };

  const onHandleSubmit = async (credentials) => {
    if (credentials.name) {
      let splitedData = credentials.name.split(" ");

      if (splitedData.length >= 2) {
        try {
          setloader(true);
          const { data } = await updateProfile({
            variables: {
              authId: id,
              data: {
                first_name: splitedData[0],
                last_name: splitedData[1],
                phone_number: credentials.phoneNumber,
                distance_travel: distance,
                location_address: credentials.address,
              },
            },
          });
          setProfileDataSave({
            title: globalVariables.profileUpdated,
            desc: globalVariables.profileUpdatedSuccessDesc,
            type: "success",
          });

          modalRef.current.openModal();
        } catch (error) {
          setProfileDataSave({
            title: "pending",
            desc: "Something went wrong",
            type: "error",
          });
          modalRef.current.openModal();
        } finally {
          setloader(false);
        }
      }
    } else {
      alert("Name is required");
    }
  };

  const onCheckValidation = () => {
    handleSubmit(onHandleSubmit)();
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col">
      <div className="flex justify-end mb-4">
        <SubmitButton
          handleCancel={() => navigate("/admin/manage/users")}
          handelSave={handelSaveChanges}
          isLoading={loader}
        />
      </div>
      <div className="hidden lg:flex" style={{ width: 280 }}></div>
      <div>
        {data?.getUserDetail?.name ? (
          <form
            ref={formRef}
            className="flex justify-center flex-col items-center pb-[24px]"
            onSubmit={handleSubmit(onHandleSubmit)}
          >
            <div className="max-[400px]:w-[90%]">
              <div className="w-full flex justify-center align-center">
                <span className="text-2xl md:text-3xl font-semibold text-gray-900 text-center mb-6">
                  {globalVariables.judgeDetails}
                </span>
              </div>
              <TextInput
                register={register}
                name="name"
                placeholder={globalVariables.enterName}
                errorMsg={errors.name?.message}
                label={globalVariables.name}
              />
              <div className="mt-5" />
              <TextInput
                register={register}
                name="email"
                placeholder={globalVariables.enterEmail}
                errorMsg={errors.email?.message}
                disabled
                label={globalVariables.emailId}
              />
              <div className="mt-5" />
              <PhoneInput
                name="phoneNumber"
                placeholder={globalVariables.enterPhoneNumber}
                errorMsg={errors.phoneNumber?.message}
                label={globalVariables.phoneNumber}
                value={watch("phoneNumber")}
                onChange={(e) => setValue("phoneNumber", e.target.value)}
              />
              <div className="mt-5" />
              <TextArea
                register={register}
                name="address"
                placeholder={globalVariables.enterYourAddress}
                errorMsg={errors.address?.message}
                label={globalVariables.address}
              />
              <div className="mt-5" />
              <Dropdown
                width="w-[100%]"
                dropdownOptions={distanceOptions}
                defaultOption={distance}
                placeholder={globalVariables.typeYourDistance}
                label={globalVariables.distanceReadyTravel}
                onChange={setDistance}
              />
            </div>
          </form>
        ) : null}
      </div>
      {showBtns ? (
        <BottomButtons
          outlineLabel={"Cancel Changes"}
          fullLabel={"Save Changes"}
          onTapYes={handelSaveChanges}
          onTapNo={() => navigate("/admin/manage/users")}
          position={isMobile ? "fixed" : "sticky"}
          extraClass={isMobile ? "h-[80px]" : "dog-signup-bb-h"}
          btnCustomWidth="w-40 lg:w-44 max-[400px]:w-[140px] max-[280px]:w-[130px]"
          hyperlinkLoading={loader}
        />
      ) : null}
      <PopUpMessages
        title={profileDataSave.title}
        desc={profileDataSave.desc}
        type={profileDataSave.type}
        ref={modalRef}
        onCloseModal={handleCancel}
      />
    </div>
  );
};

export default EditAbleJudgeProfile;
